import { format, isValid, parseISO } from "date-fns"

/** yyyy-MM-dd for `<input type="date">` and persisted splits, or "" if missing, Unknown, or invalid. */
export function execution_date_for_date_input(raw: string | null | undefined): string {
  if (raw == null) return ""
  const trimmed = raw.trim()
  if (trimmed === "") return ""
  if (trimmed.toLowerCase() === "unknown") return ""

  if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
    const d = parseISO(trimmed)
    return isValid(d) ? format(d, "yyyy-MM-dd") : ""
  }

  const d = parseISO(trimmed)
  return isValid(d) ? format(d, "yyyy-MM-dd") : ""
}

if (import.meta.vitest) {
  const { describe, expect, it } = import.meta.vitest

  describe("execution_date_for_date_input", () => {
    it("returns empty for undefined, empty, whitespace, and Unknown", () => {
      expect(execution_date_for_date_input(undefined)).toBe("")
      expect(execution_date_for_date_input("")).toBe("")
      expect(execution_date_for_date_input("   ")).toBe("")
      expect(execution_date_for_date_input("Unknown")).toBe("")
      expect(execution_date_for_date_input("UNKNOWN")).toBe("")
    })

    it("returns yyyy-MM-dd for valid ISO date-only strings", () => {
      expect(execution_date_for_date_input("2024-06-15")).toBe("2024-06-15")
    })

    it("returns empty for invalid calendar date and non-ISO garbage", () => {
      expect(execution_date_for_date_input("not-a-date")).toBe("")
      expect(execution_date_for_date_input("01/15/2024")).toBe("")
    })
  })
}
